import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewPasswordTokenComponent } from './new-password-token.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule, MatCheckboxModule, MatInputModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    FlexLayoutModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule
  ],
  declarations: [NewPasswordTokenComponent]
})
export class NewPasswordTokenModule { }



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/pages/auth/new-password-token/new-password-token.module.ts